'use strict';
import * as $j_com$002eraquo$002eairstream$002eownership$002e$002dDynamic$002dSubscription$0024 from "./com.raquo.airstream.ownership.-Dynamic-Subscription$.js";
import * as $j_com$002eraquo$002elaminar$002elifecycle$002e$002dMount$002dContext from "./com.raquo.laminar.lifecycle.-Mount-Context.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_ReactiveElement$() {
}
export { $c_Lcom_raquo_laminar_nodes_ReactiveElement$ as $c_Lcom_raquo_laminar_nodes_ReactiveElement$ };
$p = $c_Lcom_raquo_laminar_nodes_ReactiveElement$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_nodes_ReactiveElement$;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_ReactiveElement$() {
}
export { $h_Lcom_raquo_laminar_nodes_ReactiveElement$ as $h_Lcom_raquo_laminar_nodes_ReactiveElement$ };
$h_Lcom_raquo_laminar_nodes_ReactiveElement$.prototype = $p;
$p.Yh = (function(element, subscribe) {
  return $j_com$002eraquo$002eairstream$002eownership$002e$002dDynamic$002dSubscription$0024.$m_Lcom_raquo_airstream_ownership_DynamicSubscription$().rr(element.fs, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((owner) => subscribe.j(new $j_com$002eraquo$002elaminar$002elifecycle$002e$002dMount$002dContext.$c_Lcom_raquo_laminar_lifecycle_MountContext(element, owner)))), true);
});
var $d_Lcom_raquo_laminar_nodes_ReactiveElement$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_nodes_ReactiveElement$, "com.raquo.laminar.nodes.ReactiveElement$", ({
  iK: 1
}));
export { $d_Lcom_raquo_laminar_nodes_ReactiveElement$ as $d_Lcom_raquo_laminar_nodes_ReactiveElement$ };
var $n_Lcom_raquo_laminar_nodes_ReactiveElement$;
function $m_Lcom_raquo_laminar_nodes_ReactiveElement$() {
  if ((!$n_Lcom_raquo_laminar_nodes_ReactiveElement$)) {
    $n_Lcom_raquo_laminar_nodes_ReactiveElement$ = new $c_Lcom_raquo_laminar_nodes_ReactiveElement$();
  }
  return $n_Lcom_raquo_laminar_nodes_ReactiveElement$;
}
export { $m_Lcom_raquo_laminar_nodes_ReactiveElement$ as $m_Lcom_raquo_laminar_nodes_ReactiveElement$ };
